import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useEntityCrud } from '../../hooks/useEntityCrud';
import ReactInputMask from 'react-input-mask';
import ReactSelect from 'react-select';
import { toast } from 'react-toastify';

const Index = () => {

    const {readData} = useEntityCrud('PersonOrderPolicy/FilterPersonOrderPolicy');
    const {readData: readBusinesses} = useEntityCrud('Business/GetAllBusiness');
    const {readData: removePersonData} = useEntityCrud('PersonOrderPolicy/RemovePersonPolicy');
    const [rows,setRows] = useState([]);
    const [filteredRows,setFilteredRows] = useState([]);
    const [businesses,setBusinesses] = useState([])
    const [businessId,setBusinessId] = useState(0)
    const [name,setName] = useState('')
    const [nationalCode,setNationalCode] = useState('')
    const [searched,setSearched] = useState(false);
    const [currentPage,setCurrentPage] = useState(1);
    const [pages,setPages] = useState(0);

    const calcPages = result => {
        let calcPages = result.length / 10;
        calcPages = calcPages > 1 ? Math.ceil(calcPages) : 1
        let pagesArray = [];
        for (let i = 1; i <= calcPages; i++)
            pagesArray.push(i);
        setPages(pagesArray);
        setCurrentPage(1);
    }

    const getData = () => {
        readData().then(({data}) => {
            if(data.status){
                setRows(data.result);
                calcPages(data.result);
                const result = [...data.result.slice(0,10)]
                setFilteredRows(result);
            }
        });
    }

    useEffect(() => {
        getData();
        readBusinesses().then(({ data }) => {
            if(data.status)
                setBusinesses([...data.result.map(business => ({label: business.title,value: business.id}))])
        })
    },[]);

    const filterData = e => {
        e.preventDefault()
        let allRows = [...rows];
        if(name)
            allRows = allRows.filter(row => row.personFullName.includes(name));
        if(nationalCode)
            allRows = allRows.filter(row => row.nationalCode.includes(nationalCode));
        if(businessId)
            allRows = allRows.filter(row => row.businessId == businessId.value);
        setFilteredRows(allRows);
        calcPages(allRows);
        setSearched(true);
        setCurrentPage(1);
    }

    const clearFilter = () => {
        setName('');
        setBusinessId(0);
        setNationalCode('');
        setFilteredRows([...rows.slice(0,10)]);
        calcPages(rows)
        setCurrentPage(1);
        setSearched(false);
    }

    const nextPage = () => {
        const skip = currentPage * 10;
        const result = [...rows.slice(skip,skip + 10)];
        setFilteredRows(result);
        setCurrentPage(currentPage + 1);
    }

    const prevPage = () => {
        const skip = (currentPage - 2) * 10;
        const result = [...rows.slice(skip,skip + 10)];
        setFilteredRows(result);
        setCurrentPage(currentPage - 1);
    }

    const downloadExcel = () => {
        // const csvContent = 'data:text/csv;charset=utf-8;';
        // let csvFile = 'ردیف,نام و نام خانوادگی,کد ملی,کسب و کار\n';
        // filteredRows.map((row,index) => {
        //     csvFile += `${++index},${row.personFullName},${row.nationalCode},${row.businessTitle}\n`;
        // })
        // const blob = new Blob([csvFile],{ type: csvContent });
        // const url = URL.createObjectURL(blob);
        // const link = document.createElement('a');
        // link.href = url;
        // link.setAttribute('download','policy-personnel-list.csv');
        // link.click();
        document.getElementById('get-excel').classList.add('btn-loading');
        const postedData = {
            excelOutput: true
        }
        if(businessId)
            postedData.businessId = businessId.value
        if(nationalCode)
            postedData.nationalCode = nationalCode
        readData(postedData).then(({ data }) => {
            if(data.status)
                window.open(data.excelPath);
        }).finally(() => {
            document.getElementById('get-excel').classList.remove('btn-loading');
        })
    }

    const removePerson = row => {
        const postedData = {
            nationalCode: row.nationalCode,
            businessId: row.businessId
        }
        removePersonData(postedData).then(({ data }) => {
            if(data.status){
                getData();
                toast.success('شخص انتخابی از لیست حذف شد');
            }else
                toast.error('عملیات مورد نظر ناموفق بود');
        })
    }
    
    return (
        <div className="card">
            <div className="card-header"><div className="card-title">مدیریت استفاده کنندگان اسنپ فود</div></div>
            <div className="card-body">
                <Link className="btn btn-primary me-2" to="import">درون ریزی لیست استفاده کنندگان</Link>
                <button className="btn btn-dark me-2" data-bs-toggle="collapse" data-bs-target="#collapseFour" href="#filter">جستجو</button>
                <button className="btn btn-success" id="get-excel" onClick={downloadExcel}>دریافت خروجی اکسل</button>
                <div id="collapseFour" className="panel-collapse collapse position-relative" role="tabpanel" aria-expanded="false">
                    <form onSubmit={e => filterData(e)} className="row mt-4">
                        <div className="col-md-3">
                            <div className="form-group">
                                <label>نام</label>
                                <input className="form-control" value={name} onChange={e => setName(e.target.value)} />
                            </div>
                        </div>
                        <div className="col-md-2">
                            <div className="form-group">
                                <label>کد ملی</label>
                                <ReactInputMask mask="9999999999"
                                    className="form-control ltr-input"
                                    value={nationalCode}
                                    onChange={e => setNationalCode(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="col-md-2" style={{position: 'relative'}}>
                            <div className="form-group">
                                <label>کسب و کار</label>
                                {!!businessId && <i className="fe fe-x clear-select-btn" onClick={() => setBusinessId(0)}></i>}
                                <ReactSelect label="شرکت"
                                    options={businesses}
                                    value={businessId}
                                    onChange={e => setBusinessId(e)}
                                    placeholder="انتخاب کنید"
                                />
                            </div>
                        </div>
                        <div className="col-md-5" style={{marginTop: 30}}>
                            <button className="btn btn-primary me-2" onClick={filterData}>جستجو</button>
                            {searched && <button className="btn btn-danger" onClick={clearFilter}>بازنشانی</button>}
                        </div>
                    </form>
                </div>
                <hr className="mb-5" />
                {filteredRows.length > 0 ? <div className="table-responsive">
                    <table className="table table-hover table-bordered">
                        <thead>
                            <tr>
                                <th>ردیف</th>
                                <th>نام و نام خانوادگی</th>
                                <th>کد ملی</th>
                                <th>کسب و کار</th>
                                <th>عملیات</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredRows.map((row,index) => <tr>
                                <td>{++index}</td>
                                <td>{row.personFullName}</td>
                                <td>{row.nationalCode}</td>
                                <td>{row.businessTitle}</td>
                                <td>
                                    <button title="حذف" onClick={e => removePerson(row)} className="btn btn-icon mb-0 btn-danger"><i className="fe fe-x"></i></button>
                                </td>
                            </tr>)}
                        </tbody>
                    </table>
                    <p>تعداد کل ردیف ها : {filteredRows.length}</p>
                    {pages.length > 1 && <div className="text-center">
                        <button className="btn btn-primary me-2" disabled={currentPage == 1} onClick={prevPage}>قبلی</button>
                        <button className="btn btn-primary" disabled={currentPage == pages.length} onClick={nextPage}>بعدی</button>
                    </div>}
                </div> : <div className="alert alert-info">
                    <p className="mb-0">تا کنون شخصی برای استفاده از اسنپ فود ثبت نشده است</p>
                </div>}
            </div>
        </div>
    )
}

export default Index